'use strict';

var index = require('../../../../../aviary-core/dist/cjs/index.cjs');

/**
 *
 */ const fontWeightMap = (theme)=>({
        [index.TYPOGRAPHY_VARIANTS.h1]: theme.ds5.weight.regular,
        [`${index.TYPOGRAPHY_VARIANTS.h1}Strong`]: theme.ds5.weight.medium,
        [index.TYPOGRAPHY_VARIANTS.h2]: theme.ds5.weight.regular,
        [`${index.TYPOGRAPHY_VARIANTS.h2}Strong`]: theme.ds5.weight.medium,
        [index.TYPOGRAPHY_VARIANTS.h3]: theme.ds5.weight.regular,
        [`${index.TYPOGRAPHY_VARIANTS.h3}Strong`]: theme.ds5.weight.medium,
        [index.TYPOGRAPHY_VARIANTS.h4]: theme.ds5.weight.regular,
        [`${index.TYPOGRAPHY_VARIANTS.h4}Strong`]: theme.ds5.weight.bold,
        [index.TYPOGRAPHY_VARIANTS.h5]: theme.ds5.weight.semibold,
        [`${index.TYPOGRAPHY_VARIANTS.h5}Strong`]: theme.ds5.weight.bold,
        [index.TYPOGRAPHY_VARIANTS.body]: theme.ds5.weight.regular,
        [`${index.TYPOGRAPHY_VARIANTS.body}Strong`]: theme.ds5.weight.bold,
        [index.TYPOGRAPHY_VARIANTS.callout]: theme.ds5.weight.semibold,
        [`${index.TYPOGRAPHY_VARIANTS.callout}Strong`]: theme.ds5.weight.bold,
        [index.TYPOGRAPHY_VARIANTS.caption]: theme.ds5.weight.regular,
        [`${index.TYPOGRAPHY_VARIANTS.caption}Strong`]: theme.ds5.weight.semibold,
        [index.TYPOGRAPHY_VARIANTS.footnote]: theme.ds5.weight.regular,
        [`${index.TYPOGRAPHY_VARIANTS.footnote}Strong`]: theme.ds5.weight.semibold,
        [index.TYPOGRAPHY_VARIANTS.subcaption]: theme.ds5.weight.medium,
        [`${index.TYPOGRAPHY_VARIANTS.subcaption}Strong`]: theme.ds5.weight.semibold,
        [index.TYPOGRAPHY_VARIANTS.smallest]: theme.ds5.weight.semibold,
        [`${index.TYPOGRAPHY_VARIANTS.smallest}Strong`]: theme.ds5.weight.bold
    });
/**
 *
 */ const fontFamilyMap = (theme)=>({
        [index.TYPOGRAPHY_VARIANTS.h1]: theme.ds5.type.family.decorative,
        [index.TYPOGRAPHY_VARIANTS.h2]: theme.ds5.type.family.decorative,
        [index.TYPOGRAPHY_VARIANTS.h3]: theme.ds5.type.family.decorative,
        [index.TYPOGRAPHY_VARIANTS.h4]: theme.ds5.type.family.base,
        [index.TYPOGRAPHY_VARIANTS.h5]: theme.ds5.type.family.base,
        [index.TYPOGRAPHY_VARIANTS.body]: theme.ds5.type.family.base,
        [index.TYPOGRAPHY_VARIANTS.callout]: theme.ds5.type.family.base,
        [index.TYPOGRAPHY_VARIANTS.caption]: theme.ds5.type.family.base,
        [index.TYPOGRAPHY_VARIANTS.footnote]: theme.ds5.type.family.base,
        [index.TYPOGRAPHY_VARIANTS.subcaption]: theme.ds5.type.family.base,
        [index.TYPOGRAPHY_VARIANTS.smallest]: theme.ds5.type.family.base
    });

exports.fontFamilyMap = fontFamilyMap;
exports.fontWeightMap = fontWeightMap;
//# sourceMappingURL=Typography.web.map.cjs.map
